import * as React from "react";

export const useOnClickOutside = (
  ref: React.RefObject<HTMLElement>,
  handler: (event: MouseEvent | TouchEvent) => void,
  listen = true
) => {
  React.useEffect(() => {
    if (!listen) return;
    const listener = (event: MouseEvent | TouchEvent) => {
      if (ref.current !== null && ref.current.contains(event.target as Node))
        return;

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [handler, ref, listen]);
};
